import * as ProductLines from 'self-service-api/constants/ProductLines';
import * as ProductLevels from 'self-service-api/constants/ProductLevels';
const paEnabledMap = {
  [ProductLines.CMS]: [ProductLevels.PROFESSIONAL, ProductLevels.ENTERPRISE],
  [ProductLines.OPERATIONS]: [ProductLevels.PROFESSIONAL, ProductLevels.ENTERPRISE]
};
export const isCtaDTTEnabled = ({
  productLine,
  productLevel
}) => {
  return (paEnabledMap[productLine] || []).includes(productLevel);
};